import { render, staticRenderFns } from "./ManageBuyOrders.vue?vue&type=template&id=3012bdd8&"
import script from "./ManageBuyOrders.vue?vue&type=script&lang=js&"
export * from "./ManageBuyOrders.vue?vue&type=script&lang=js&"
import style0 from "./ManageBuyOrders.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ManageBuyOrders.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports